import { useState, useCallback, useMemo } from "react";
import toast from "react-hot-toast";
import { fetchAllPlayers } from "../services/player-lists-service";

export function usePlayerSearch(existingPlayers) {
  const [allPlayers, setAllPlayers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const loadAll = useCallback(async () => {
    if (allPlayers.length > 0 || loading) return;
    setLoading(true);
    try {
      const sorted = await fetchAllPlayers();
      setAllPlayers(sorted);
    } catch {
      toast.error("Failed to load players");
    } finally {
      setLoading(false);
    }
  }, [allPlayers.length, loading]);

  const results = useMemo(() => {
    const s = searchTerm.toLowerCase().trim();
    if (!s) return [];
    const existingIds = new Set(existingPlayers.map((p) => (p.player_id || "").toString()));
    return allPlayers
      .filter((p) => !existingIds.has((p.player_id || "").toString()))
      .filter(
        (p) =>
          p.player_name?.toLowerCase().includes(s) ||
          p.team_name?.toLowerCase().includes(s)
      )
      .slice(0, 8);
  }, [searchTerm, allPlayers, existingPlayers]);

  return { searchTerm, setSearchTerm, results, loading, loadAll };
}
